/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Create_TeamInputs */

const th_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างทีมที่โรงเรียนของคุณ`)
};

const en_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a team at your school`)
};

const ja_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所属校でチームを作る`)
};

const zh_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在你的学校创建球队`)
};

const es_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear un equipo en tu centro`)
};

const pt_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar um time na sua escola`)
};

const id_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat tim di sekolah Anda`)
};

const fr_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer une équipe dans votre établissement`)
};

const tl_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gumawa ng team sa paaralan mo`)
};

const vi_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo đội ở trường bạn`)
};

const ko_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`학교에 팀 만들기`)
};

const de_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team an deiner Schule anlegen`)
};

const ru_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать команду в вашей школе`)
};

const tr_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okulunuzda takım kurun`)
};

const it_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea una squadra nella tua scuola`)
};

const pl_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Załóż drużynę w swojej szkole`)
};

const uk_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Створити команду у вашій школі`)
};

const hi_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने स्कूल में टीम बनाएँ`)
};

const ar_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنشئ فريقًا في مدرستك`)
};

const ms_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cipta pasukan di sekolah anda`)
};

const bn_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার স্কুলে দল গড়ুন`)
};

const zh_tw2_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在你的學校建立球隊`)
};

const zh_hk2_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在你的學校建立球隊`)
};

const ur_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اپنے اسکول میں ٹیم بنائیں`)
};

const fa_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ساختن تیم در مدرسه‌تان`)
};

const sw_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fungua timu shuleni kwako`)
};

const nl_home_create_team = /** @type {(inputs: Home_Create_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een team op je school`)
};

/**
* | output |
* | --- |
* | "Create a team at your school" |
*
* @param {Home_Create_TeamInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_create_team = /** @type {((inputs?: Home_Create_TeamInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Create_TeamInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_home_create_team(inputs)
	if (locale === "ja") return ja_home_create_team(inputs)
	if (locale === "zh") return zh_home_create_team(inputs)
	if (locale === "es") return es_home_create_team(inputs)
	if (locale === "pt") return pt_home_create_team(inputs)
	if (locale === "id") return id_home_create_team(inputs)
	if (locale === "fr") return fr_home_create_team(inputs)
	if (locale === "tl") return tl_home_create_team(inputs)
	if (locale === "vi") return vi_home_create_team(inputs)
	if (locale === "ko") return ko_home_create_team(inputs)
	if (locale === "de") return de_home_create_team(inputs)
	if (locale === "ru") return ru_home_create_team(inputs)
	if (locale === "tr") return tr_home_create_team(inputs)
	if (locale === "it") return it_home_create_team(inputs)
	if (locale === "pl") return pl_home_create_team(inputs)
	if (locale === "uk") return uk_home_create_team(inputs)
	if (locale === "hi") return hi_home_create_team(inputs)
	if (locale === "ar") return ar_home_create_team(inputs)
	if (locale === "ms") return ms_home_create_team(inputs)
	if (locale === "bn") return bn_home_create_team(inputs)
	if (locale === "zh-TW") return zh_tw2_home_create_team(inputs)
	if (locale === "zh-HK") return zh_hk2_home_create_team(inputs)
	if (locale === "ur") return ur_home_create_team(inputs)
	if (locale === "fa") return fa_home_create_team(inputs)
	if (locale === "sw") return sw_home_create_team(inputs)
	if (locale === "nl") return nl_home_create_team(inputs)
	return en_home_create_team(inputs)
});